// Main admin panel interface

import Card from './Card';
import Tabs from './Tabs';
import TeamsList from './TeamsList';
import TournamentsList from './TournamentsList';
import PaymentsList from './PaymentsList';
import RefereesList from './RefereesList';
import CoachesList from './CoachesList';
import './AdminPanelCard.scss';

export default function AdminPanelCard() {
  return (
    <Card header='Admin panel' className='admin-panel'>
      <Tabs
        className='admin-panel-tabs'
        tabs={[
          {
            title: 'Tournaments',
            hash: '#tournaments',
            component: <TournamentsList />,
          },
          {
            title: 'Teams',
            hash: '#teams',
            component: <TeamsList />,
          },
          {
            title: 'Coaches',
            hash: '#coaches',
            component: <CoachesList />,
          },
          {
            title: 'Referees',
            hash: '#referees',
            component: <RefereesList withAssigners />,
          },
          {
            title: 'Payments',
            hash: '#payments',
            component: <PaymentsList />,
          },
        ]}
      />
    </Card>
  );
}
